export default "__VITE_ASSET__BBb9H2_I__"